<template>
  <div class="container">
    <camera v-if="showCamera"
      :imagesList="photoType"
      v-on:closecamera="closeCamera">
    </camera>
    <preloader v-if="showPreloader"></preloader>
    <b-alert
      :show="dismissCountDown"
      dismissible
      fade
      variant="primary"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
      >
        {{allertMessage}}
    </b-alert>
    <h1 class="text-center">
      <base-button v-on:click="goToJobs" class="mt-1 back-button" size="md" type="primary">Back</base-button>
      {{jobId}}
      <span v-if="getCurrentJobInfo" class="block">{{getCurrentJobInfo.locationName || ''}}</span>
      <span v-if="getCurrentJobInfo" class="block">{{getCurrentJobInfo.address || ''}}</span>
      </h1>
    <div class="card card-profile shadow mb-1">
      <div class="card-body sm">
        <b-list-group>
          <b-list-group-item class="sm">
            <base-button outline
              v-if="!activeJob.isStarted && checkIsCurrentJobFinishedAndActiveJobAvailability"
              v-on:click="startJob()"
              size="md"
              class="mb-1" type="primary">Start job</base-button>
            <base-button outline
              size="md"
              v-if="activeJob.isStarted && checkIsCurrentJobFinishedAndActiveJobAvailability"
              v-on:click="endJob(activeJob.id)" class="mb-1"  type="primary">End job</base-button>
            <base-button outline
            size="md"
            v-if='showSkipFormAndButton'
            v-on:click="skip" class="mb-1"  type="primary">Skip Job</base-button>
            <base-button outline
            size="md"
            v-on:click="navigate()" class="mb-1"  type="primary">Navigate</base-button>
            <span v-if="activeJob.isStarted && checkIsCurrentJobFinishedAndActiveJobAvailability" class="block mt-1">{{activeJob.startTime | moment("h:mm, dd, MM YY")}}</span>
          </b-list-group-item>
          <b-list-group-item class="sm" v-if="!isCurrentJobActive(currentJob) && !isCurrentJobFinished(currentJob)">
            <div v-if="showSkipForm">
              <form @submit.prevent="skipJob(currentJob)">
                <div class="form-group text-left">
                  <label for="jobSkipReason">Please write the reason</label>
                  <textarea class="form-control"
                    id="jobSkipReason"
                    v-model="jobSkipReason"
                    name="jobSkipReason"
                    :class="{'is-invalid': vErrors.first('jobSkipReason') }"
                    v-validate="'required'"
                    data-vv-validate-on="blur"
                    rows="3">
                  </textarea>
                  <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors">
                      <span>{{ vErrors.first('jobSkipReason') }}</span>
                  </div>
                </div>
                <div class="text-center">
                  <base-button outline v-on:click="showSkipForm=false" size="md" type="primary">Cancel</base-button>
                  <base-button nativeType='submit' size="md" type="primary">Skip Job</base-button>
                </div>
              </form>
            </div>
          </b-list-group-item>
        </b-list-group>
      </div>
    </div>
    <div class="card card-profile shadow mb-1" v-for="(stand, index) in stands" :key='index'>
      <div class="card-body sm text-right">
        <div class="job-action-wrapper container-fluid">
          <div class="row">
            <div class="col-sm text-left">
              <span  class="block">
                {{stand.standID}}
              </span>
              <span  class="block">
                {{stand.sectorName}}
              </span>
              <template v-if="checkIfStandIsDelivery(stand.class)">
                <span  class="block">
                  <strong>Delivery</strong>
                </span>
                <span  class="block">
                  <strong>{{stand.product}} - {{stand.quantity}}</strong>
                </span>
              </template>
            </div>
            <div class="col-sm  text-left">
              <span class="block">
                {{stand.pockets}}
              </span>
              <span  class="block">
                {{stand.type}}
              </span>
            </div>
            <div class="col-sm  text-left">
              <span class="block">
                {{stand.headerName}}
              </span>
            </div>
            <div class="col-sm  text-left">
              <base-button
                v-if="showStartJobAction(currentJob, stand.standID)"
                class="mb-2" size="md" v-on:click="startJobAction(stand.standID, stand.class, stand.deliveryId, stand.product, stand.quantity, stand.headerCapableDrivers, stand.canBeRelocated, stand.outletWithin6Feet)"
                type="primary">Start job actions
              </base-button>
              <base-button v-if="showEndJobAction(currentJob, stand.standID)" class="mb-1" size="md" v-on:click="endJobActions()" type="primary">End job actions
              </base-button>
              <base-button v-if="showViewJobActionsButton(stand)" v-on:click="goToStand(stand.standID)" class="mb-1" size="md" type="primary">View job actions</base-button>
              <base-checkbox
                v-if="showStartJobAction(currentJob, stand.standID)"
                v-model="showJobActionSkip[index]">
                  Unable to do
              </base-checkbox>
            </div>
          </div>
        </div>
        <div class="job-action-wrapper container-fluid">
          <form @submit.prevent v-if="showJobActionSkip[index]">
            <div class="form-group text-left">
              <label :for="'hello-' + index">Please write the reason</label>
              <textarea class="form-control"
                :id="'jobActionSkipReason-' + index"
                v-model="jobActionSkipReason[index]"
                :name="'jobActionSkipReason-' + index"
                :class="{'is-invalid': vErrors.first('jobActionSkipReason-' + index) }"
                v-validate="'required'"
                data-vv-validate-on="blur"
                data-vv-as="Reason"
                rows="3">
              </textarea>
              <div class="text-danger invalid-feedback" style="display: block;" v-if="vErrors.first('jobActionSkipReason-' + index)">
                  <span>{{ vErrors.first('jobActionSkipReason-' + index) }}</span>
              </div>
            </div>
            <div class="text-left">
              <a v-on:click='takePicture(["jobActionSkipPhoto", index])' class="link"><i class="fa fa-camera" aria-hidden="true"></i> Tap to take picture</a>
            </div>
            <div class="text-center">
              <!-- <base-button outline v-on:click="showJobActionSkip[standID]=false" size="sm" type="primary">Cancel</base-button> -->
              <base-button size="md" v-on:click="jobActionSkip(stand.standID, stand.class, index, stand.deliveryId, stand.product, stand.quantity)" type="primary">Submit</base-button>
            </div>
          </form>
        </div>
        <b-list-group>
          <b-list-group-item class="sm text-center" v-if="standIscompleted(currentJob, stand.standID)">
            <strong >Completed</strong>
          </b-list-group-item>
        </b-list-group>
      </div>
    </div>
  </div>
</template>
<script>
import alertMixin from './../mixins/alertMixin'
import jobsMixin from './../mixins/jobsMixin'
import standsMixin from './../mixins/standsMixin'
import shiftMixin from './../mixins/shiftMixin'
import jobActionsMixin from './../mixins/jobActionsMixin'
import timestampMixin from './../mixins/timestampMixin'
import stateUpdateMixin from './../mixins/stateUpdateMixin'
import camera from './../../components/Camera'
import jobActionFormMixin from './../mixins/jobActionFormMixin'
export default {
  data () {
    return {
      showCamera: false,
      showPreloader: false,
      jobId: null,
      stands: null,
      showSkipForm: false,
      jobSkipReason: '',
      jobActionSkipReason: [],
      jobActionSkipPhoto: [],
      showJobActionSkip: []
    }
  },
  mounted () {
    // Getting id from route params
    this.jobId = +this.$route.params.id
    this.getStands()
    this.checkForActiveStandAndRedirect()
  },
  computed: {
    activeJob () {
      return this.$store.state.activeJob
    },
    startJobActionIsAvaible () {
      if (this.activeJob.isStarted && this.jobId === this.activeJob.id && !this.activeStand) return true
      return false
    },
    showStartJobAction () {
      return function (jobId, standId) {
        let stands = this.$store.state.stands

        let stand = stands.find(s => s.standId === standId && s.jobId === jobId)

        let standHasCompletedActions = this.$store.state.completedJobActions.some(jobAction => jobAction.standId === standId && jobAction.jobId === jobId)

        if (jobId !== this.activeJob.id) return false

        if (this.activeStand && this.activeStand.standId !== standId) return false

        if (!stand) return true

        return !stand.isCompleted && !stand.isSkipped && (this.getJobActionFormId(stand.class) === 6 || !standHasCompletedActions)
      }
    },
    showEndJobAction () {
      return function (jobId, standId) {
        let stands = this.$store.state.stands

        let stand = stands.find(s => s.standId === standId && s.jobId === jobId)

        let standHasCompletedActions = this.$store.state.completedJobActions.some(jobAction => jobAction.standId === standId && jobAction.jobId === jobId)

        return jobId === this.activeJob.id && stand && stand.isActive && !stand.isCompleted && !stand.isSkipped && standHasCompletedActions
      }
    },
    showSkipFormAndButton () {
      let currentJob = this.currentJob
      return !this.isCurrentJobActive(currentJob) && !this.isCurrentJobFinished(currentJob)
    },
    checkIsCurrentJobFinishedAndActiveJobAvailability () {
      return this.activeJobAvailability && !this.isCurrentJobFinished(this.jobId)
    }
  },
  methods: {
    goToCustomForm (formLabel) {
      this.$store.commit('setCurrentCustomForm', formLabel)
      this.$router.push({ path: '/customform' })
    },
    checkForActiveStandAndRedirect () {
      // let activeStand = this.activeStand
      // if (!activeStand) return
      // let standClass = activeStand.class
      // let jobActionFormId = this.getJobActionFormId(standClass)
      // // If stand contains all job action type we do not need redirect
      // if (jobActionFormId === 6) return
      // // If we do not have active job we do no need to redirect user
      // if (!this.currentJob || !this.activeJob) return
      // // If job action of active stand is completed we do no need to redirect user
      // if (this.isJobActionCopleted(jobActionFormId)) return
      // if (this.currentJob === this.activeJob.id) this.$router.push({ name: 'jobaction', params: { action: jobActionFormId } })
    },
    closeCamera (data) {
      this.showCamera = false
      this[data[1][0]][data[1][1]] = data[0][0]
      this.removeClassFromBody()
    },
    showViewJobActionsButton (stand) {
      return this.getJobActionFormId(stand.class) === 6 && !this.standIscompleted(this.currentJob, stand.standID)
    },
    skip () {
      this.showSkipForm = !this.showSkipForm
    },
    navigate () {
      let currentJobInfo = this.getCurrentJobInfo
      let addressArray = [currentJobInfo.city || '', currentJobInfo.address, currentJobInfo.country || '']
      let address = addressArray.join(' ')
      let encodeAddress = encodeURI(address)
      let href = `https://www.google.com/maps/dir/?api=1&destination=${encodeAddress}`
      window.location.href = href
    },
    startJob () {
      // If shift is not started return
      if (!this.shiftIsStarted) return this.showAlert(3, 'Please start shift before')
      let timeStamp = this.getCurrentTime()
      let data = {
        id: this.jobId,
        startTime: timeStamp
      }
      this.showPreloader = true
      this.$store.dispatch('startJob', data)
        .then(response => {
          if (response) {
            this.showPreloader = false
            this.$store.commit('startJob', data)
            // Updating state on serer
            this.stateUpload()
          }
        })
        .catch(err => {
          this.showPreloader = false
          console.log(err)
          if (this.isOnline) this.showAlert(5, err.response.data.result.message)
          if (this.isOffline) {
            this.$store.commit('startJob', data)
          }
        })
    },
    skipJob (jobId) {
      let self = this
      this.$validator.validateAll({
        jobSkipReason: this.jobSkipReason
      }).then(function (result) {
        if (result) {
          let skipJobObj = {
            jobId: jobId,
            skipReason: self.jobSkipReason,
            time: self.getCurrentTime()
          }
          self.showPreloader = true
          self.$store.dispatch('skipJob', skipJobObj).then(response => {
            if (response) {
              self.showPreloader = false
              self.deleteJob(jobId)
              self.goToJobs()
            }
          }).catch(err => {
            console.log(err)
            self.showPreloader = false
            if (self.isOnline) this.showAlert(5, err.response.data.result.message)
            if (self.isOffline) {
              self.deleteJob(jobId)
              self.goToJobs()
            }
          })
        }
      })
    },
    deleteJob (jobId) {
      this.$store.commit('deleteJob', jobId)
    },
    startJobAction (standId, standClass, standDeliveryId, standProduct, standQuantity, standHeaderCapableDrivers, canBeRelocated, outletWithin6Feet) {
      // Need to reset Job data, created from tablet
      this.$store.commit('resetJobCreatedFromTabled')
      if (this.isJobActionSkipped(standId, this.currentJob)) return this.showAlert(3, 'This job action already skipped')
      let jobId = this.$store.state.activeJob.id
      let stands = this.$store.state.stands
      let jobActionFormId = this.getJobActionFormId(standClass)
      if (!jobActionFormId) return this.showAlert(6, 'Unknown stand class. Please try to re-login')
      if (stands.length === 0 || !stands.find(stand => stand.standId === standId && stand.jobId === jobId)) {
        this.createStand(standId, standClass, jobId, standDeliveryId, standProduct, standQuantity)
      }
      // Setup current stand
      this.$store.commit('setAciveStand', [standId, jobId])
      this.$store.commit('setCurrentStand', standId)
      // If we have jobActionFormId with all stands then go to the list of all jobactions
      if (jobActionFormId === 6) {
        return this.$router.push('/jobactions')
      }

      this.$router.push({ name: 'jobaction', params: { action: jobActionFormId, headerCapableDrivers: standHeaderCapableDrivers, canBeRelocated: canBeRelocated, outletWithin6Feet: outletWithin6Feet } })
    },
    endJob (jobId) {
      if (!this.checkIfAllCurrentStandsAreCompletedOrSkipped()) return this.showAlert(3, 'You have unfinished jobactions')
      let endTime = this.getCurrentTime()
      let standsCount = this.getCurrentJobInfo.stands.length
      let dataObj = {
        endTime,
        jobId,
        standsCount
      }
      this.finishedCurrentJob(jobId)
      this.showPreloader = true
      this.$store.dispatch('endJob', dataObj)
        .then(response => {
          if (response) {
            this.showPreloader = false
            this.$store.commit('endJob', endTime)
            this.$store.commit('deleteJob', jobId)
            // Check if we have active stand and finish job action
            if (this.activeStand) this.endJobActions()
            // Updating state on serer
            this.stateUpload()
            this.goToJobs()
          }
        })
        .catch(err => {
          this.showPreloader = false
          console.log(err)
          if (this.isOnline) this.showAlert(5, err.response.data.result.message)
          if (this.isOffline) {
            this.$store.commit('endJob', endTime)
            this.$store.commit('deleteJob', jobId)
            if (this.activeStand) this.endJobActions()
            this.goToJobs()
          }
        })
    },
    async jobActionSkip (standId, standClass, index, standDeliveryId, standProduct, standQuantity) {
      let self = this
      let pictures = await this.getImagesFromIndexedDb(self.jobActionSkipPhoto)
      this.$validator.validateAll({
        [`jobActionSkipReason-${index}`]: self.jobActionSkipReason[index]
      }).then(function (result) {
        if (result) {
          let dataObj = {
            token: self.$store.state.user.token,
            jobId: self.jobId,
            formType: 'standProblem',
            jobType: 'server',
            images: [],
            time: self.getCurrentTime(),
            records: JSON.stringify({ standProblem: self.jobActionSkipReason[index], standProblemPhoto: pictures[0] }),
            standId: standId
          }
          self.showPreloader = true
          self.$store.dispatch('sendJobAction', dataObj)
            .then(response => {
              if (response) {
                self.showPreloader = false
                let stands = self.$store.state.stands
                if (stands.length === 0 || !stands.find(stand => stand.standId === standId && stand.jobId === self.jobId)) {
                  self.createStand(standId, standClass, self.jobId, standDeliveryId, standProduct, standQuantity)
                }
                self.$store.commit('skipStand', { 'standId': standId, 'jobId': self.jobId })
                self.jobActionSkipReason[index] = null
                self.showJobActionSkip[index] = null
                if (self.activeStand) self.endJobActions()
                self.showAlert(3, 'Job action skipped succes')
              }
            })
            .catch(err => {
              self.showPreloader = false
              if (self.isOnline) self.showAlert(5, err.response.data.result.message)
              if (self.isOffline && self.activeStand) self.endJobActions()
              console.log(err)
            })
        }
      })
    },
    // Getting stands which are related to current job
    getStands () {
      let jobArray = this.$store.state.driverJobs
      // Getting jobs array with id matched in route params
      let job = jobArray.filter((job) => {
        return job.id === this.jobId
      })
      // If we do not have job, something wrong go to jobs list
      if (job.length === 0) return this.goToJobs()
      this.stands = job[0].stands
    },
    goToStand (standId) {
      this.$store.commit('setCurrentStand', standId)
      this.$router.push({ name: 'jobactions' })
    },
    goToJobs () {
      this.$router.push({ name: 'jobs' })
    },
    checkIfAllCurrentStandsAreCompletedOrSkipped () {
      let currentStands = this.stands
      let activeJobId = this.activeJob.id
      let completedStands = this.getCompletedStands()
      let skippedStands = this.getSkippedStands()
      let completedAndskippedStands = [...completedStands, ...skippedStands]
      // if we do not have completed stands return false
      if (completedAndskippedStands.length === 0) return false
      // Define array with equals stands
      let arraySame = []
      // Iterate stands, related to active job
      currentStands.forEach(stand => {
        // Find in completed stands stand with same standId and JobId
        let sameElement = completedAndskippedStands.filter(item => item.jobId === activeJobId && item.standId === stand.standID)
        // If we have thoose element then push it to arraySame
        if (sameElement.length > 0) arraySame.push(sameElement)
      })
      // Check the length of this arrays
      // If it is the same all stands related to active job are comlited
      return currentStands.length === arraySame.length
    },
    checkIfStandIsDelivery (standClass) {
      let jobActionFormId = this.getJobActionFormId(standClass)
      return jobActionFormId === 4
    }
  },
  components: {
    camera
  },
  mixins: [jobActionFormMixin, jobsMixin, standsMixin, shiftMixin, alertMixin, timestampMixin, stateUpdateMixin, jobActionsMixin]
}
</script>
<style scoped>
  .job-action-wrapper {
    padding-top: 15px;
    padding-bottom: 15px;
    font-size: 0.75rem;
  }
  .block {
    display: block;
  }
  h1 {
    font-size: 1.2rem;
    padding: 0.5rem 0;
  }
</style>
